// import React from 'react';
// import { Bar } from 'react-chartjs-2';

// export default function ReviewersStatisticsGridItem({ data }) {
//   return (
//     <div className="p-2 bg-white border-2 border-muted-500">
//       <h3 className="text-base font-medium">{data.question}</h3>
//       <div className="flex justify-center">
//         <Bar
//           data={data.chartData}
//           options={{
//             responsive: true,
//             plugins: {},
//             scales: {
//               x: { display: false },
//               y: { beginAtZero: true, ticks: { stepSize: 1, precision: 0 } },
//             },
//           }}
//         />
//       </div>
//       <div className="flex flex-wrap">
//         {data.colors.map((color, idx) => (
//           <div key={idx} className="flex items-center w-1/2 gap-4">
//             <div style={{ width: 20, height: 20, backgroundColor: color }} />
//             <span>{data.labelsFull[idx]}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }





import React from 'react';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

export default function ReviewersStatisticsGridItem({ data }) {
  const totalCount = data.chartData.datasets[0].data.reduce((acc, val) => acc + val, 0);

  return (
    <div className="p-2 bg-white border-2 border-muted-500 rounded-xl">
      <h3 className="text-base font-medium mb-1">{data.question}</h3>
      <p className="text-sm text-muted-900 mb-2">المجموع :
        <span className="mr-2 font-large text-succes">
          {totalCount}
        </span>
      </p>

      {/* <div className="flex justify-center">
        <Bar
          data={data.chartData}
          options={{
            responsive: true,
            plugins: {
              datalabels: {
                anchor: 'center',
                align: 'center',
                clip: true,
                color: '#000000',
                font: {
                  weight: 'bold',
                  size: 15,
                },
                formatter: Math.round,
              },
            },
            scales: {
              x: { display: false },
              y: {
                beginAtZero: true,
                ticks: { stepSize: 1, precision: 0 },
              },
            },
          }}
        />
      </div> */}

      <div className="flex justify-center">
        <Bar
          data={data.chartData}
          options={{
            responsive: true,
            plugins: {
              datalabels: {
                anchor: 'center',
                align: 'center',
                clip: false, // important: pour que le texte ne soit pas coupé
                color: '#FFFFFF',
                font: {
                  weight: 'bold',
                  size: 13,
                },
                formatter: Math.round,
              },
            },
            scales: {
              x: {
                display: false,
                grid: { display: false },
                ticks: { display: false },
              },
              y: {
                beginAtZero: true,
                ticks: { stepSize: 1, precision: 0 },
                grid: { drawTicks: false },
              },
            },
            indexAxis: 'y',
            elements: {
              bar: {
                barThickness: 20, // ⬅️ épaisseur contrôlée ici
                borderRadius: 2,
              },
            },
          }}
        />
      </div>


      <div className="flex flex-wrap mt-4">
        {data.colors.map((color, idx) => (
          <div key={idx} className="flex items-center w-1/2 gap-4 mb-1">
            <div style={{ width: 20, height: 20, backgroundColor: color }} />
            <span>{data.labelsFull[idx]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
